import { useSmartQuery } from "@shared/api/queries/hooks";
import { getMeterRuns, getMeterRunCounts, getMeterRunDetail, getRoutes, getMeterReadings, getReaderEfficiencySummary, getReaderEfficiencyList, getMeterDispatchDetail } from "./api";
import { PAGE_SIZE } from "@shared/utils/constants";

export const useMeterRuns = (
    page: any,
    utilityId: any,
    collection_methods?: string,
    limit: number = PAGE_SIZE,
    search?: string
) => {
    return useSmartQuery(
        ["mx", "meter-run", page, utilityId, collection_methods, limit, search],
        () => getMeterRuns(page, utilityId, collection_methods, limit, search),
        {
            enabled: !!utilityId,
        }
    );
};

export const useMeterRunCounts = (utilityId: any) => {
    return useSmartQuery(
        ["mx", "meter-run", "counts", utilityId],
        () => getMeterRunCounts(utilityId),
        {
            enabled: !!utilityId,
        }
    );
};

export const useMeterRunDetail = (id: any, utilityId: any, meterType?: string) => {
    return useSmartQuery(
        ["mx", "meter-run", "detail", id, utilityId, meterType],
        () => getMeterRunDetail(id, utilityId, meterType),
        {
            enabled: !!id && !!utilityId,
        }
    );
};

export const useRoutes = (
    page: any,
    utilityId: any,
    limit: number = PAGE_SIZE,
    cycleId?: any,
    search?: string
) => {
    return useSmartQuery(
        ["mx", "route", page, utilityId, limit, cycleId, search],
        () => getRoutes(page, utilityId, limit, cycleId, search),
        {
            enabled: !!utilityId,
        }
    );
};

export const useMeterReadings = (
    page: any,
    utilityId: any,
    meterRunId: any,
    limit: number = PAGE_SIZE,
    search?: string,
    utilityService?: string,
    type?: string,
    subType?: string,
    condition?: string,
    status?: string
) => {
    return useSmartQuery(
        ["mx", "meter-reading", page, utilityId, meterRunId, limit, search, utilityService, type, subType, condition, status],
        () => getMeterReadings(page, utilityId, meterRunId, limit, search, utilityService, type, subType, condition, status),
        {
            enabled: !!utilityId && !!meterRunId,
        }
    );
};

export const useReaderEfficiencySummary = (
    utilityId: any,
    meterRunId: any
) => {
    return useSmartQuery(
        ["mx", "reader-efficiency-summary", utilityId, meterRunId],
        () => getReaderEfficiencySummary(utilityId, meterRunId),
        {
            enabled: !!utilityId && !!meterRunId,
        }
    );
};

export const useReaderEfficiencyList = (
    page: any,
    utilityId: any,
    meterRunId: any,
    limit: number = PAGE_SIZE
) => {
    return useSmartQuery(
        ["mx", "reader-efficiency-list", page, utilityId, meterRunId, limit],
        () => getReaderEfficiencyList(page, utilityId, meterRunId, limit),
        {
            enabled: !!utilityId && !!meterRunId,
        }
    );
};

export const useMeterDispatchDetail = (params: {
    meter_run_id: any;
    remote_utility_id: any;
    page: number;
    origin: string;
    meter_reader_id?: any;
    run_status?: string;
    search?: string;
}) => {
    return useSmartQuery(
        ["mx", "meter-dispatch", "detail", params],
        () => getMeterDispatchDetail(params),
        {
            enabled: !!params.meter_run_id && !!params.remote_utility_id,
        }
    );
};
